<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="process-steps-title" :field="fields?.title" tag="h2" />
      <JssRichText class="process-steps-desc" :field="fields?.subtitle" />
      <div class="process-steps-wrap">
        <div class="process-steps-card" v-if="fields?.list?.length > 0">
          <div
            class="process-steps-card-item"
            v-for="(item, index) in fields?.list"
            :key="index"
            :style="{ backgroundColor: item?.fields?.backgroundColor?.value }"
          >
            <JssRichText class="process-steps-list-item-card" :field="item?.fields?.card" />
          </div>
        </div>
        <div class="process-steps-list" v-if="fields?.list?.length > 0">
          <div class="process-steps-list-line"></div>
          <div
            v-for="(item, index) in fields?.list"
            :key="index"
            class="process-steps-list-item"
            :class="{ 'align-center': index == 1 }"
          >
            <div class="process-steps-list-item-icon">
              <AdaptiveImage
                :field="item?.fields?.image"
                :isBackground="false"
                :lazy-load="false"
                :enableScrollDetection="false"
                :show="true"
              />
            </div>
            <div class="process-steps-list-item-desc" v-if="item?.fields?.list?.length > 0">
              <div
                class="process-steps-list-item-desc-item"
                v-for="data in item?.fields?.list"
                :key="data"
              >
                <JssRichText
                  class="process-steps-list-item-desc-item-time"
                  :field="data?.fields?.time"
                />
                <JssRichText
                  class="process-steps-list-item-desc-item-title"
                  :field="data?.fields?.title"
                />
              </div>
            </div>
            <JssRichText
              class="process-steps-list-item-tag"
              :field="item?.fields?.tag"
              v-if="index != 1"
            />
            <JssRichText
              class="process-steps-list-item-title"
              :field="item?.fields?.title"
              tag="h3"
              v-if="index != 1"
            />
            <JssRichText
              class="process-steps-list-item-subtitle"
              :field="item?.fields?.desc"
              v-if="index != 1"
            />
          </div>
        </div>
      </div>
      <div class="process-steps-footer" v-if="fields?.footerDesc?.value">
        <JssRichText class="process-steps-footer-text" :field="fields?.footerDesc" />
        <SiteButton v-bind="fields?.button" />
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'ProcessSteps',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'process-steps'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.process-steps {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    text-align: center;
  }

  &-desc {
    font-size: 14px;
    line-height: 1.6;
    color: $black;
    margin-top: 8px;
    text-align: center;
  }

  &-card {
    display: flex;
    gap: 16px;
    margin-top: 24px;
    width: 100%;
    white-space: nowrap;

    &-item {
      flex-shrink: 0;
      border-radius: 8px;
      color: $white;
      padding: 6px 32px;
      font-size: 14px;
      min-width: 200px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }

  &-wrap {
    width: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &-list {
    display: flex;
    gap: 40px;
    margin-top: 24px;
    position: relative;

    &-line {
      position: absolute;
      width: 635px;
      left: 0;
      top: 30px;
      height: 2px;
      background: linear-gradient(90deg, #d4d4d4, #a8a8a8);
    }

    &-item {
      display: flex;
      flex-direction: column;
      flex: 1;
      align-items: center;
      text-align: center;
      &.align-center {
        flex: none;
        width: 62px;
        position: relative;

        &:after {
          content: '';
          position: absolute;
          top: 62px;
          left: 30px;
          width: 2px;
          height: calc(100% - 62px);
          background: linear-gradient(90deg, #d4d4d4, #a8a8a8);
        }
      }

      &-icon {
        width: 62px;
        height: 62px;

        image {
          width: 100%;
          height: 100%;
        }
      }

      &-desc {
        margin-top: 24px;
        width: 100%;
        display: flex;
        text-align: center;
        justify-content: space-between;
        gap: 16px;

        &-item {
          display: inline-flex;
          flex-direction: column;
          gap: 8px;
          align-items: center;
          flex: 1;

          &-time {
            padding: 4px 8px;
            border-radius: 2px;
            background: #eff5e8;
            font-size: 14px;
            color: $grey-black;
            white-space: nowrap;
          }

          &-title {
            font-size: 18px;
            font-weight: 700;
            line-height: 1.4;
            color: $grey-black;
          }
        }
      }

      &-title {
        font-size: 14px;
        font-weight: 700;
        line-height: 1.4;
        color: $grey-black;
        font-weight: 600;
        margin-top: 16px;
        text-align: left;
      }

      &-subtitle {
        font-size: 12px;
        line-height: 1.4;
        color: $grey-black;
        margin-top: 8px;
        text-align: left;
      }

      &-tag {
        width: 100%;
        font-size: 14px;
        background: #fdfaf6;
        padding: 16px;
        border-radius: 8px;
        color: #656565;
        margin-top: 16px;
        border: 1px solid #dbc9ac;
        text-align: left;
      }
    }
  }

  &-footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
    background: $grey-neutral;
    border-radius: 4px;
    padding: 20px 16px;
    gap: 16px;

    &-text {
      font-size: 14px;
      color: $grey-black;
      font-weight: 500;
      text-align: center;
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-desc {
      font-size: 18px;
    }

    &-card {
      display: flex;
      gap: 35px;
      margin-top: 24px;
      width: 100%;

      &-item {
        flex: 1;
        border-radius: 8px;
        color: $white;
        font-size: 18px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 48px;
      }
    }

    &-list {
      margin-top: 40px;

      &-line {
        width: 100%;
      }

      &-item {
        &.align-center {
          &:after {
            height: calc(100% - 62px);
            top: 62px;
            left: 30px;
          }
        }
      }
    }

    &-footer {
      flex-direction: row;
      justify-content: space-between;
      margin-top: 36px;
      padding: 10px 12px 10px 24px;

      &-text {
        font-size: 16px;
      }
    }
  }
}
</style>
